import { useMemo, useState } from "react";
import { Button } from "../../../components/Button";
import { TextInput } from "../../../components/TextInput";
import { ReactComponent as AlertIcon } from "../../../assets/icons/Alert.svg";

import { ClientQuizFormType } from "./ClientQuiz";
import { zipCodes } from "../../../assets/data/zip_codes";

export function Step1({
  onNext,
  clientQuizForm,
  setClientQuizForm
}: {
  onNext: () => void;
  clientQuizForm: ClientQuizFormType;
  setClientQuizForm: (value: ClientQuizFormType) => void;
}) {
  const [errors, setErrors] = useState({} as any);
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);

  const isZipValid = (code: string) => code && (code.trim().length === 5 && !isNaN(parseInt(code, 10)) && !!zipCodes[code])
  const [zipCity, zipState] = useMemo(() => {
    return clientQuizForm.zipCode && isZipValid(clientQuizForm.zipCode) ? [zipCodes[clientQuizForm.zipCode]?.city, zipCodes[clientQuizForm.zipCode]?.state_short] : [undefined, undefined];
  }, [clientQuizForm.zipCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "zipCode") {
      if (isZipValid(e.target.value)) {
        setErrors({ ...errors, zipCode: undefined })
      }
    }

    setClientQuizForm({ ...clientQuizForm, [name]: value } as ClientQuizFormType);
  };

  const validateAndNext = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!clientQuizForm.zipCode || !isZipValid(clientQuizForm.zipCode)) {
      newErrors = { ...newErrors, 'zipCode': "Please provide client's valid five digit zip code" };
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
    }

    onNext();
  };

  const disabled = useMemo(() => {
    return !clientQuizForm.zipCode || !isZipValid(clientQuizForm.zipCode)
  }, [clientQuizForm]);

  return (
    <>
      <div className="bg-white p-8 rounded-[16px]">
        <form className="mt-4 flex flex-col gap-[22px]" onSubmit={validateAndNext}>
          <div className="flex flex-col md:flex-row items-center gap-3">
            <div className="w-full lg:w-[50%] max-w-[250px] flex flex-col gap-1.5">
              <div className="text-primary font-bold">1.</div>
              <label className="text-lg text-black/80">
                What is your zip code?
              </label>
              <TextInput
                name="zipCode"
                value={clientQuizForm.zipCode}
                onChange={handleChange}
                placeholder="Enter your zip code"
                maxLength={5}
              />
              {(zipCity && zipState) && <div className="text-xs">{zipCity}, {zipState}</div>}
              {errors.zipCode && (
                <div className="text-red-500 text-xs font-medium">
                  {errors.zipCode}
                </div>
              )}
            </div>
            <div />
          </div>

          <div className="mt-7">
            {error && (
              <div className="text-red-500 text-xs font-medium mb-4 flex items-center gap-1">
                <AlertIcon /> {error}
              </div>
            )}
            <Button
              type="submit"
              variant="primary"
              className="!rounded-full w-full"
              disabled={disabled || saving}
              loading={saving}
              onClick={validateAndNext}
            >
              Next
            </Button>
          </div>
        </form>
      </div>

    </>
  );
}
